import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { format } from 'date-fns'
import VuePaginateAl from 'vue-paginate-al'
import OtpInput from '@bachdgvn/vue-otp-input'
import ApiService from '@/services/api.service.js'
import VueTailwind from 'vue-tailwind'
import TDatepicker from 'vue-tailwind/dist/t-datepicker'
import VCalendar from 'v-calendar'
import { errorInterceptor } from '@/utils/interceptors'
import Notification from './utils/notification-factory'
import Toasted from 'vue-toasted'
import '@/style/notification.scss'
const api = new ApiService()

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.prototype.ApiService = api
store.$api = api

Vue.component('vue-paginate-al', VuePaginateAl)
Vue.component('v-otp-input', OtpInput)

Vue.prototype.ApiService.axios.interceptors.response.use(null, errorInterceptor)

Vue.filter('formatDate', val => {
  if (!val) return ''
  return format(new Date(val), 'PPP')
})

Vue.filter('formatDateTime', val => {
  return format(new Date(val), 'PPpp')
})

Vue.filter('gradeDescription', val =>
  val
    ? val
      .split('_')
      .map(w => `${w[0].toUpperCase()}${w.substring(1)}`)
      .join(' ')
    : ''
)

const settings = {
  't-datepicker': {
    component: TDatepicker,
    props: {
      lang: 'es'
    }
  }
}

Vue.use(VueTailwind, settings)
Vue.use(VCalendar)
Vue.use(Toasted, Notification.settings)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
